import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/api';
import '../styles/StaffPages.css';
import headerImage from '../assets/images/header.png';

const Login = ({ onAuthChange }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    if (errors[e.target.name]) {
      setErrors({
        ...errors,
        [e.target.name]: ''
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      await apiService.login(formData.email, formData.password);
      onAuthChange && onAuthChange();
      navigate('/');
    } catch (error) {
      if (error.response?.status === 400 || error.response?.status === 401) {
        setErrors({ general: 'Invalid email or password. Please try again.' });
      } else if (error.response?.data) {
        setErrors(error.response.data);
      } else {
        setErrors({ general: 'Login failed. Please try again.' });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex align-center justify-center" style={{ minHeight: '100vh' }}>
      <div className="container-narrow">
        <div className="add-reward-section auth-form-section" style={{ maxWidth: '400px', margin: '0 auto', marginTop: 0 }}>
          <div className="text-center mb-4">
            <img src={headerImage} alt="HomeCrowd" style={{ maxWidth: '250px', height: 'auto', marginBottom: '20px' }} />
          </div>

          {errors.general && (
            <div className="alert alert-error">
              {errors.general}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
                placeholder="Enter your email"
              />
              {errors.email && (
                <div className="text-error mt-1" style={{ fontSize: '14px' }}>
                  {errors.email}
                </div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">
                Password
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                className="form-input"
                placeholder="Enter your password"
              />
              {errors.password && (
                <div className="text-error mt-1" style={{ fontSize: '14px' }}>
                  {errors.password}
                </div>
              )}
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`staff-page-button ${loading ? 'disabled' : ''}`}
              style={{ width: '100%', justifyContent: 'center' }}
            >
              <span className="staff-page-button-text">
                {loading ? 'Signing In...' : 'Sign In'}
              </span>
            </button>
          </form>

        </div>
      </div>
    </div>
  );
};

export default Login;
